var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-box" },
    [
      _vm.imgPreviewUrl.length
        ? _c("el-image", {
            ref: "previewImg",
            staticStyle: { display: "none" },
            attrs: {
              src: _vm.imgPreviewUrl,
              "preview-src-list": _vm.imgPreviewUrl,
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "content-box" }, [
        _c(
          "div",
          { staticClass: "flex flex-between padding-bottom-25 title-box" },
          [
            _c("span", { staticClass: "color-333 font-20 font-weight" }, [
              _vm._v(_vm._s(_vm.info.title)),
            ]),
            _c(
              "div",
              _vm._l(_vm.info.label, function (item, index) {
                return _c(
                  "span",
                  {
                    key: index,
                    staticClass: "margin-left-15 label-item font-14 font-light",
                  },
                  [_vm._v(_vm._s(item))]
                )
              }),
              0
            ),
          ]
        ),
        _c("div", {
          staticClass: "margin-top-25",
          domProps: { innerHTML: _vm._s(_vm.info.content) },
        }),
        _c("div", { staticClass: "flex flex-align-center margin-top-30" }, [
          _c("span", { staticClass: "color-999 font-14 margin-right-40" }, [
            _vm._v(_vm._s(_vm.info.createTime)),
          ]),
          _c("div", { staticClass: "flex flex-align-center" }, [
            _c("img", {
              staticStyle: { width: "16px", height: "16px" },
              attrs: { src: require("./static/icon_article_pageView.png") },
            }),
            _c("span", { staticClass: "color-999 font-14 margin-left-5" }, [
              _vm._v(
                _vm._s(_vm.info.pageView > 999 ? "999+" : _vm.info.pageView)
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }